const parsedStoreNames = [
  'Sheetz',
  'Burger King',
  'Primanti Bros',
  "Wendy's",
  'Dollar General',
  "Monte Cello's",
  "Cenci's Pizza",
  'Taco Bell',
  'TEQUILA JALISCO MEXICAN RESTAURANT',
  "Applebee's",
  'Jade palace',
  '7-Eleven',
  "McDonald's",
  'Great Wall Chinese Restaurant',
  'Chick-fil-A',
  'Buffalo Wild Wings',
  'Condado Tacos',
  'Pizza Hut',
  'Red Robin',
  'Noodles & Company',
  'Crumbl Cookies',
  'SEPHORA',
  'Dairy Queen',
  "Arby's",
  'Subway',
  'China Palace',
  'China House',
  'CHiKN',
  'Real Thai Cuisine',
  'Saga Steakhouse & Sushi Bar',
  'CCC0098125',
  'Smokey Bones Bar & Fire Grill',
  "Aladdin's Eatery",
  'Panera',
  "Big Shot Bob's Mars",
  'Chipotle',
  'Firebirds Wood Fired Grill',
  'K ASIAN BISTRO',
  'Carrols LLC',
  'Mad Mex',
  'Five Guys',
  'Aldi Grocery Marketplace',
  'Giant Eagle',
  'The Sports Grille at Cranberry',
  'Blaze Pizza',
  'The Wing Experience',
  "Pizza Joe's",
  "Eat' N Park",
  'El Campesino',
  'Vocelli Pizza',
  "DiBella's",
  "Stack'd Burgers & Beer",
  "Bruster's",
  'Walgreens',
  'The Burger Experience',
  "Moe's Southwest Grill",
  'Avor Thai Restaurant',
  'Red Lobster',
  'JJ Panda',
  'Patron Mexican Grill',
  "Jersey Mike's Subs",
  "BullDawg's",
  "Stoke's Grill",
  "Jersey Mike's",
  'Rite Aid',
  'PetSmart',
  'CVS',
  'GetGo',
  'Freshii',
  'Penn Station East Coast Subs',
  'Mintt Pizza',
  'Burgatory',
  'Target',
  'Hong Kong Taste',
  'MenuSifu',
  "Denny's",
  "Chili's Grill & Bar",
  'Waffles, INCaffeinated',
  'Alioto’s Sports Bar & Restaurant',
  'VERONA',
  'Piada Italian Street Food',
  'VANDERGRIFT',
  "It's Just Wings",
  'CCC0115762',
  "Chili's",
  'Starbucks',
  '18th Street Pizza',
  'CCC0127948',
  'Speedway',
  'Hello Bistro Pine',
  "Graeter's Ice Cream",
  'Nothing Bundt Cakes',
  'Naturoll Creamery',
  "Emiliano's Mexican Restaurant",
  "Peppino's Pizza",
  'Bowl Market',
  'Sir Pizza',
  'LOWER BURRELL',
  'Donatos',
  'Pulp Juice and Smoothie Bar-Cranberry PA',
  'KFC',
  'Mad Mex',
  'Panera MP',
  'Cracker Barrel',
  'Los Cabos Mexican Restaurant',
  "Frank's Pizza & Chicken",
  'Advance Auto Parts',
  "Eat'n Park",
  'Cold Stone Creamery',
  'Staples',
  'American Natural',
  'Primanti Bros.',
  'Tractor Supply',
  "Anthony's Coal Fired Pizza",
  'Aviva Brick Oven',
  "Dunkin'",
  'The Cheesecake Factory',
  'Italian Oven',
  'Ales On 6th',
  "Dee Jay's BBQ Ribs & Grille",
  'Wingstop',
  'Fresh Thyme',
  "Big Shot Bob's House of Wings",
  'TEPACHE MEXICAN KITCHEN & BAR',
  "Aladdin's Eatery",
  "Jason's Deli",
]

export default parsedStoreNames
